import { useState } from 'react';
import { X } from 'lucide-react';

import { currencyFormat } from '@/helpers/stringHelpers';
import { formatDateAndTime } from '@/helpers/dateHelpers';

import { Button } from '@/components/ui/button';

import { useActivities } from '@/data/activity';

const CartItem = ({ item, onRemove }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const activities = useActivities();

  const activity = activities.data.find(
    (activity) => activity.id === item.activityId
  );

  const handleRemove = async () => {
    setIsDeleting(true);
    await onRemove(item.id);
    setIsDeleting(false);
  };

  return (
    <div className="py-3 px-3 border rounded-md">
      <div className="flex justify-between items-start mb-1">
        <h4 className="text-sm truncate flex-1">{item.label}</h4>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6 ml-2 -mt-1 -mr-1"
          onClick={handleRemove}
          aria-label="Remove item"
          disabled={isDeleting}
        >
          <X className="h-3.5 w-3.5" />
        </Button>
      </div>

      <div className="flex">
        <div className="flex-1 min-w-0">
          <div className="text-xs text-muted-foreground">
            <div className="font-medium text-muted-foreground">
              {activity.title} {item.location && `- ${item.location.name}`}
            </div>
            <div>{formatDateAndTime(item.startDateTime)}</div>
          </div>
          <div className="flex items-center text-xs mt-1">
            <span>{currencyFormat(item.price)}</span>
            <span className="mx-1">×</span>
            <span>{item.quantity}</span>
          </div>
        </div>
        <div className="ml-3 items-end h-full text-right">
          <span className="font-medium text-sm block mb-1">
            {currencyFormat(item.subtotal)}
          </span>
          <span className="font-medium text-xs block text-muted-foreground">
            (Payout {currencyFormat(item.coachPayout)})
          </span>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
